import { render, staticRenderFns } from "./AppCadastroUsuario.vue?vue&type=template&id=9a0adf10&"
import script from "./AppCadastroUsuario.vue?vue&type=script&lang=js&"
export * from "./AppCadastroUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports